import { getSearchParams } from './search-params'
import { ApplicationParam } from '../interfaces'

export function getUrlParam(name: ApplicationParam): string {
  const params = getSearchParams()
  let value = params.get(name)

  if (value) {
    sessionStorage.setItem(name, value)
  } else {
    value = sessionStorage.getItem(name)
  }

  return value || ''
}
